import { BACKEND_CONFIG, validateBackendConfig } from './backendConfig';
import { getLocalBackendUrl, resolveApiBaseUrl, getRoutingDebugInfo } from './backendRouting';

// API Configuration (BASE_URL is read lazily so same-origin works after load)
export const API_CONFIG = {
  get BASE_URL() {
    return getLocalBackendUrl();
  },
  ENDPOINTS: {
    DATA_RAW: BACKEND_CONFIG.API_ENDPOINTS.DATA_RAW,
    DATA_CALCULATED: BACKEND_CONFIG.API_ENDPOINTS.DATA_CALCULATED,
    DATA_ACCUMULATED: BACKEND_CONFIG.API_ENDPOINTS.DATA_ACCUMULATED,
    SUMMARY: BACKEND_CONFIG.API_ENDPOINTS.SUMMARY,
    UPLOAD: BACKEND_CONFIG.API_ENDPOINTS.UPLOAD,
    LOGIN: BACKEND_CONFIG.API_ENDPOINTS.LOGIN,
    VERIFY: BACKEND_CONFIG.API_ENDPOINTS.VERIFY,
    VERIFY_URL: BACKEND_CONFIG.API_ENDPOINTS.VERIFY_URL,
    VERIFY_FLEXIBLE: BACKEND_CONFIG.API_ENDPOINTS.VERIFY_FLEXIBLE,
    LOGOUT: BACKEND_CONFIG.API_ENDPOINTS.LOGOUT,
    SESSIONS: BACKEND_CONFIG.API_ENDPOINTS.SESSIONS,
    HEALTH: BACKEND_CONFIG.API_ENDPOINTS.HEALTH,
    TEST_API: BACKEND_CONFIG.API_ENDPOINTS.TEST_API
  }
};

// Development mode detection
export const isDevelopment = process.env.NODE_ENV === 'development';

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = resolveApiBaseUrl(endpoint).replace(/\/+$/, '');
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  if (!baseUrl) {
    return cleanEndpoint;
  }
  return `${baseUrl}${cleanEndpoint}`;
};

// Helper function to get local API URL for development (if needed)
export const getLocalApiUrl = (endpoint: string): string => {
  return `https://rtl-market.modernmoneyexperts.com${endpoint}`;
};

// Helper function to get production API URL (canonical host, not same-origin shortcut)
export const getProductionApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${BACKEND_CONFIG.PRIMARY_URL.replace(/\/+$/, '')}${cleanEndpoint}`;
};

// Validate backend configuration on import
validateBackendConfig();

// Log current API configuration for debugging
console.log('🔍 [API] Configuration:', {
  environment: process.env.NODE_ENV,
  baseUrl: API_CONFIG.BASE_URL,
  isDevelopment: isDevelopment,
  backend: BACKEND_CONFIG.PRIMARY_URL,
  routing: getRoutingDebugInfo()
}); 